export const STEP_ID_GENERAL_INFORMATIONS = 'informations-generales'
export const STEP_ID_NOTIFICATIONS = 'notifications'
export const STEP_ID_PROVIDERS = 'synchronisations'
export const STEP_ID_MANAGEMENT = 'gestion-structure'

export const STEP_NAMES = [
  STEP_ID_GENERAL_INFORMATIONS,
  STEP_ID_MANAGEMENT,
  STEP_ID_NOTIFICATIONS,
  STEP_ID_PROVIDERS,
]
